import { Component, EventEmitter, Input, Output } from '@angular/core';
import type { ColumnDataDate, ColumnDataDateTime } from '@ov-suite/helpers-shared';
import moment from 'moment';

@Component({
  selector: 'ov-suite-date-time-cell',
  template: `
    <span *ngIf="!col.editable">
      {{ getDateTime(item[col?.key]) }}
    </span>
    <ov-suite-input
      *ngIf="col.editable"
      type="date-time"
      [style]="{ height: '38px' }"
      [(ngModel)]="item[col?.key]"
      (ngModelChange)="itemChanged(item)"
    ></ov-suite-input>
  `,
})
export class DateTimeCellComponent<T> {
  @Input() item: T;
  @Input() col: ColumnDataDateTime<T>;
  @Output() itemChange = new EventEmitter<T>();

  itemChanged(item: T): void {
    this.itemChange.emit(item);
  }

  getDateTime(date?: Date): string {
    if (!date) {
      return '';
    }
    return moment(date).format('DD MMM YYYY, HH:mm');
  }
}
